export default __webpack_public_path__ + "static/media/Shadow's Fauld of the Tenth Court.68bc8f9d.jpg";